import { useEffect, useState } from "react";
import { useCheckoutContext } from "../../../context/useCheckoutContext";
import { configCardSections } from "../../../shared/constants/CheckoutContants";
export var usePaymentMethod = function () {
    var _a = useCheckoutContext(), _b = _a.handlers, setCheckoutSection = _b.setCheckoutSection, setSectionRedirection = _b.setSectionRedirection, paymentMethods = _a.paymentMethods, paymentType = _a.paymentType, emailKpay = _a.emailKpay, readOnly = _a.readOnly;
    var _c = useState([]), paymentMethodsList = _c[0], setPaymentMethodsList = _c[1];
    var getKpayRedirection = function () {
        if (emailKpay) {
            setCheckoutSection(configCardSections.kpayPaymentSelect);
        }
        else {
            setCheckoutSection(configCardSections.kpayEmail);
        }
    };
    useEffect(function () {
        setPaymentMethodsList(paymentMethods);
    }, [paymentMethods, paymentType]);
    return {
        handlers: {
            getKpayRedirection: getKpayRedirection,
            getSectionRedirection: setSectionRedirection,
        },
        paymentMethodsList: paymentMethodsList,
        readOnly: readOnly,
    };
};
